import styled from 'styled-components';
import { ShadowBoxDark } from 'app/components';
import { textTransform } from 'utils';

const titleOffset = `30px`;

export const SectionCinemas = styled.section.attrs({
  className: 's-cinemas'
})`
  flex: 1 0 auto;
  padding: 0 0 48px;

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    .fixed-cinema-date-location{
    position: fixed;
    width: 100%;
    background-color: black;
    left: 0;
    z-index: 5;
    top:46px;
    }
    .cinema-list{
      margin-top: 104px;
    }
  }
  
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}){
    .cinema-list{
      margin-top: 80px;
    }
  }
`;

export const CinemasListItem = styled(ShadowBoxDark).attrs({
  className: 'l-cinemas__item'
})`
  width: 100%;
  padding: ${({ theme }) => `${theme.indent.m} ${theme.indent.s}`};

  & + & {
    margin-top: ${({ theme }) => theme.indent.m};
  }

  .l-cinemas__link-wrapper {
    margin-left: ${({ theme }) => theme.indent.s};
    ${({ isLoggedIn }) => isLoggedIn && `padding-left: ${titleOffset};`}
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: 1.5px;
    text-transform: ${textTransform};
    color: ${({ theme }) => theme.color.accent};
    position: relative;
    
    .btn-favorite {
      position: absolute;
      left: 0;
    }
  }

  .l-cinemas__link {
    transition: color .2s ease-out;

    &:hover {
      color: ${({ theme }) => theme.color.textPrimary};
    }
  }

  .l-cinemas__address {
    margin: ${({ theme }) => `${theme.indent.xs} 0 0 ${theme.indent.s}`};
    ${({ isLoggedIn }) => isLoggedIn && `padding-left: ${titleOffset};`}
    font-size: 1.4rem
    color: ${({ theme }) => theme.color.textPrimary};
    letter-spacing: .1px;
  }

  .l-cinemas__no-movies {
    margin: 6px 0 0 8px;
    font-size: 1.6rem;
    color: ${({ theme }) => theme.color.labelColor};
  }
  
  .carousel {
    margin-top: ${({ theme }) => theme.indent.m};
  }
  
  .l-cinemas__movie-link {
    display: block;
    margin: ${({ theme }) => `0 ${theme.indent.s}`}; 
    
    .b-image-with-loader__img {
      transition: transform 0.4s ease-out;
    }

    &:hover {
      .b-image-with-loader__img {
        transform: scale(1.05);
        will-change: transform;
      }
    }
  }
`;

export const FavBtn = styled.button.attrs({
  type: 'button',
  className: 'btn-favorite'
})`
  .l-cinemas & {
    width: 22px;
    height: 22px;
    position: absolute;
    left: -30px;
    font-size: 0;

    .svg-star {
      width: 18px;
      height: 18px;
      stroke: ${({ theme }) => theme.color.accent};
    }

    &:hover {
      .svg-star {
        fill: ${({ theme }) => theme.color.accent};
      }
    }

    &._selected {
      .svg-star {
        fill: ${({ theme }) => theme.color.accent};
      }
    }
  }

  .svg-star {
    stroke-width: 2px;
    fill: transparent;
    transition: fill 0.2s ease-out;
  }

  &._pending {
    pointer-events: none;

    .svg-star {
      opacity: 0.7;
      animation: rotate 0.3s ease-out infinite alternate;
    }
  }

  .s-cinema-details & {
    display: inline-block;
    vertical-align: middle;
    margin-right: ${({ theme }) => theme.indent.s};
    padding: 2px 0px;
    width: 24px;
    height: 24px;

    .svg-star {
      width: 20px;
      height: 20px;
      stroke: ${({ theme }) => theme.color.textPrimary};
    }

    &:hover {
      .svg-star {
        fill: ${({ theme }) => theme.color.textPrimary};
      }
    }

    &._selected {
      .svg-star {
        fill: ${({ theme }) => theme.color.textPrimary};
      }
    }
  }
`;
